exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2bb42413] .sale-order-table th{padding:0 3px!important}", ""]);

// exports
